import { FC, memo } from 'react'

import { useForm } from '@tanstack/react-form'
import { FF } from 'ui/components'
import { CompanySelect } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { FilterWrapper } from 'ui/temp/Filter'
import { TableFilterRow } from 'ui/temp/TableFilterRow'
import { useAlertsContext } from '~bank-alerts/context'
import { AlertsPayload } from '~bank-alerts/types'

import * as SC from './styles'

export const Filter: FC = memo(() => {
  const { data, search, onFilterChange } = useAlertsContext()
  const { relationshipOptions, form } = data

  const formApi = useForm({
    defaultValues: {
      quarterlyAnalyticsCompanyID: form.quarterlyAnalyticsCompanyID
    }
  })

  const clearForm = () => {
    formApi.reset()
    onFilterChange(
      {
        quarterlyAnalyticsCompanyID: undefined,
        quarterlyAnalyticsPage: 1
      },
      'quarterlyAnalytics'
    )
  }

  const updateSearchParams = (newValue: Partial<AlertsPayload>) => {
    onFilterChange({ ...search, ...newValue, quarterlyAnalyticsPage: 1 }, 'quarterlyAnalytics')
  }

  const hasActiveFilters = Boolean(search.quarterlyAnalyticsCompanyID)

  return (
    <FilterPanel isDirty={hasActiveFilters} onReset={clearForm} expanded={false}>
      <FilterWrapper>
        <TableFilterRow>
          <SC.ItemWrapper>
            <formApi.Field
              name="quarterlyAnalyticsCompanyID"
              listeners={{
                onChange: ({ value }) => {
                  updateSearchParams({ quarterlyAnalyticsCompanyID: value })
                }
              }}
              children={(field) => (
                <FF
                  field={field}
                  label="Relationships"
                  input={(inputProps) => (
                    <CompanySelect hideMyCompaniesFilter preloadedOptions={relationshipOptions} {...inputProps} />
                  )}
                />
              )}
            />
          </SC.ItemWrapper>
        </TableFilterRow>
      </FilterWrapper>
    </FilterPanel>
  )
})
